import { usePlan } from "@/features/auth/hooks/usePlan";
import { useIsFeatureHidden } from "@/shared/hooks/useAppSettings";

const CSE_MESSAGES_FEATURE_CODE = "service_cse_messages";

export const useHasCseMessagesAccess = (): boolean => {
  const plan = usePlan();
  const isHidden = useIsFeatureHidden(CSE_MESSAGES_FEATURE_CODE);

  return !!plan?.features.service_cse_messages && !isHidden;
};
